import { z } from 'zod'

/** Slug the API sends in `filter[payment_tags_in]` for loads with no Payment tags. */
export const NO_PAYMENT_TAGS = '__none__'

/** System Payment tag (and Company tag) for VIP companies. */
export const VIP_TAG_SLUG = 'vip'

export const GetPaymentTagTypeSchema = z.object({
  // A system type, such as VIP, cannot be deleted.
  is_system: z.boolean(),
  name: z.string(),
  slug: z.string(),
})

export const GetPaymentTagSchema = z.object({
  name: z.string(),
  slug: z.string(),
})

export type GetPaymentTag = z.infer<typeof GetPaymentTagSchema>
